export default __webpack_public_path__ + "static/media/Russiantournamettable_11zon.19008280.webp";